import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/ActivityList'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { activityList } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = activityList.name
  static widget = Widget
  static configure = createConfigure(activityList)
}
